// Gated on hostname, not MODE/DEV -- `vite build` always sets MODE to "production"
// regardless of whether the output lands on a Cloudflare Pages preview URL or the
// real production domain, so a MODE check would hide this on preview too, where we
// actually need it. app.cyukltd.com is the only hostname this is hidden on.
export default function SentryTest() {
  if (typeof window !== 'undefined' && window.location.hostname === 'app.cyukltd.com') {
    return <div>Not available</div>
  }

  return (
    <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'flex-start' }}>
      <h1>Sentry Test</h1>
      <button onClick={() => { throw new Error('Sentry frontend test — safe to ignore') }}>
        Throw frontend error
      </button>
      <button onClick={async () => {
        const r = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/sentry-test-edge`, {
          headers: { apikey: import.meta.env.VITE_SUPABASE_ANON_KEY },
        })
        console.log(r)
      }}>
        Throw edge error
      </button>
    </div>
  )
}
